// @flow
export { default, StyledButton } from './LinkButton';
export type { Props } from './LinkButton';



// WEBPACK FOOTER //
// ../react-lib/src/components/buttons/LinkButton/index.js